<template>
  <v-dialog v-model="dialog" max-width="600px">
    <v-card style="padding-bottom: 10px;">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card-title>
          <span class="headline">{{ title }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  id="mid"
                  v-model="form.mid"
                  label="MID"
                  :disabled="true"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  id="merchant_name"
                  v-model="form.merchant_name"
                  label="Nama Merchant"
                  :disabled="true"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  id="serial_number"
                  v-model="form.sn"
                  label="Serial Number"
                  :rules="[ 
                    (v) => isAddMode && isModified ? (!!v || 'Serial Number is required') : true, 
                    (v) => !v || !/\s/.test(v) || 'Serial Number must not contain spaces'
                  ]"
                  @input="markAsModified"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-form>
      <v-card-actions>
        <v-spacer />
        <v-btn dark color="red" @click="cancel">Cancel</v-btn>
        <v-btn
          color="primary"
          :disabled="loading || !valid"
          :loading="loading"
          @click="save"
        >Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    value: {
      type: Boolean,
      required: true
    },
    formData: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      dialog: this.value,
      form: { ...this.formData },
      valid: false,
      isModified: false
    };
  },
  computed: {
    isAddMode() {
      return this.mode === 'add';
    }
  },
  watch: {
    value(val) {
      this.dialog = val;
      if (val) {
        this.resetForm();
      }
    },
    dialog(val) {
      this.$emit('input', val);
    },
    formData: {
      handler(newFormData) {
        this.form = { ...newFormData };
        this.isModified = false;
      },
      deep: true,
    },
  },
  methods: {
    resetForm() {
      this.form = { ...this.formData };
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
      });
      this.isModified = false;
    },
    cancel() {
      this.dialog = false;
      this.$emit('cancel');
    },
    markAsModified() {
      this.isModified = true;
    },
    async save() {
      if (this.$refs.form.validate() && this.isModified) {
        try {
          this.$emit('save', this.form);
        } catch (error) {
          this.$store.commit('setSnackbar', {
            status: true,
            message: 'something went wrong!',
            icon: 'mdi-alert-circle',
            color: 'red',
          });
        }
      }
    }
  }
};
</script>
